export function formatters() {
    function formatCurrency(value = null) {
        if (value === null) {
            return null;
        }
        return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    }
    function formatDate(dateString = null, withTime = false) {
        if (!dateString) {
            return null;
        }
        const date = new Date(dateString);
        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        };
        if (withTime) {
            options.hour = '2-digit';
            options.minute = '2-digit';
        }
        return new Intl.DateTimeFormat('de-DE', options).format(date);
    }
    return {
        formatCurrency,
        formatDate
    };
}
